import BaseStatisticBlock from "../BaseStatisticBlock";
import { DisplayVariant } from "../constants";
import { type StatisticsBlock, type StatisticsModuleType } from "../types";

interface MapperProps {
  module: StatisticsModuleType;
  block: StatisticsBlock;
}

export default function Mapper(props: MapperProps) {
  const {
    module: {
      style: {
        display: { displayVariant },
      },
    },
    block,
  } = props;

  switch (displayVariant) {
    case DisplayVariant.Variant1:
    case DisplayVariant.Variant2:
      return <BaseStatisticBlock block={block} />;
    default:
      return null;
  }
}
